<template>
  <div :id="`accept-` + applicant.job_applicant_id" class="applicant-link">
    <div class="card">
      <router-link
        v-if="!withdrawn"
        :to="{
          name: 'view-applicant',
          params: { id: applicant.job_applicant_id }
        }"
        title="Bekijk"
        class="card-body"
        :class="declined ? 'bg-cancelled' : ''"
        v-ripple="'rgba(192, 189, 187, 0.35)'"
      >
        <div class="card-top-row">
          <div v-if="parseInt(applicant.is_declined)" class="declined">
            Kandidaat afgewezen
          </div>
          <div v-else-if="parseInt(applicant.is_interview_invited)" class="recent">
            Recent uitgenodigd
          </div>
          <div v-else-if="parseInt(applicant.is_interested)" class="recent">
            Recent benaderd
          </div>
          <div v-else-if="parseInt(applicant.percentage) && !withdrawn && sub_branch !== '2'" class="match_percentage">
            {{ parseInt(applicant.percentage) }}% match
          </div>
        </div>
        <div class="applicant-card-image">
          <img v-if="applicant.avatar" :src="applicant.avatar" class="img-item" />
          <svg-icon v-else icon="person_male" class="img-item"/>
          <div class="sd-title bold">
            {{ applicant.firstname }}
          </div>
        </div>
        <div class="applicant-card-spec">
          <div v-if="sub_branch !== '2'">
            {{ getWorkingDays().totalMatchedDays }}/{{ getWorkingDays().totalDays }} dagen beschikb.
          </div>
          <div v-if="applicant.matching_subject">
            {{ applicant.matching_subject }}
          </div>
          <div v-if="applicant.matching_subject">
            {{ getEducationExperience() }}
          </div>
          <div class="achievements_container" v-if="applicant.achievements && applicant.achievements.length">
            <achievements :achievements="applicant.achievements" size="small"></achievements>
          </div>
        </div>
        <button
          v-if="accept && !withdrawn"
          type="button"
          v-on:click.stop="onAccept(applicant.job_applicant_id)"
          class="btn btn-light btn-block"
        >
          Aannemen
        </button>
      </router-link>
      <div v-else class="card-body bg-cancelled">
        <div class="card-top-row">
          <div v-if="parseInt(applicant.is_interested)" class="recent">Recent benaderd</div>
          <div v-if="parseInt(applicant.is_interview_invited)" class="recent">Recent uitgenodigd</div>
        </div>
        <div class="applicant-card-image">
          <img v-if="applicant.avatar" :src="applicant.avatar" class="img-item" />
          <svg-icon v-else icon="person_male" class="img-item"/>
          <div class="sd-title bold">
            {{ applicant.firstname }}
          </div>
        </div>
        <div class="applicant-card-spec">
          <div v-if="sub_branch !== '2'">
            <svg-icon icon="calendar"></svg-icon>
            {{ getWorkingDays().totalMatchedDays }}/{{ getWorkingDays().totalDays }} dagen beschikb.
          </div>
          <div v-if="applicant.city_location" class="location">
            <svg-icon icon="marker"></svg-icon>
            <span v-if="applicant.name_location">{{ applicant.name_location }} ({{ applicant.city_location }})</span>
            <span v-else>{{ applicant.city_location }}</span>
          </div>
          <div class="achievements_container" v-if="applicant.achievements && applicant.achievements.length">
            <achievements :achievements="applicant.achievements" size="small"></achievements>
          </div>
          <div v-if="withdrawn" class="text-center mt-2">
            <strong>Sollicitatie ingetrokken</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";

export default {
  props: {
    applicant: Object,
    accept: Boolean,
    view: Boolean,
    dayData: Object,
  },
  data() {
    return {
      sub_branch: localStorage.getItem("subBranch"),
      withdrawn: false,
      declined: false
    };
  },
  async mounted() {
    this.declined = this.applicant.is_declined;
    this.withdrawn = this.applicant.is_withdrawn;
  },
  computed: {
    func() {
      const func = JSON.parse(this.applicant.experience);
      if (typeof func !== 'undefined' && typeof func["position"] !== 'undefined' && func["position"][0]) {
        return func["position"][0];
      }
      return "-";
    },
    subtitle() {
      let working_dates = JSON.parse(JSON.parse(this.applicant.working_dates));
      let formatedFirstDate = new Date(Object.keys(working_dates)[0]).toLocaleDateString();
      let _subtitle = "";
      if (Object.keys(working_dates).length > 1) {
        _subtitle = formatedFirstDate + ": meerdere dagen";
      } else {
        _subtitle = formatedFirstDate + ": één dag";
      }
      return _subtitle;
    }
  },
  methods: {
    async onAccept(id) {
      this.$emit("notification", "comment");
      this.$emit("job-applicant-id-change", id);
    },
    getEducationExperience() {

      if(this.applicant.matching_education_level) {
        return this.applicant.matching_education_level
      }

      return null;
    },
    getWorkingDays() {
      let totalDays = {},
        totalMatchedDays = 0,
        workingDates = 0,
        unmatched_reasons = 0;

      if(this.applicant.unmatched_reasons)
      {
        let temp_unmatched_reasons = JSON.parse(this.applicant.unmatched_reasons);

        if(temp_unmatched_reasons && temp_unmatched_reasons.dates)
          unmatched_reasons = temp_unmatched_reasons.dates.length;
      }

      workingDates = Object.keys(JSON.parse(JSON.parse(this.applicant.working_dates))).length;

      totalMatchedDays = workingDates - unmatched_reasons;

      totalDays = {
        'totalDays': workingDates,
        'totalMatchedDays': totalMatchedDays,
      };

      return totalDays;
    }
  },
  components: {
    Achievements
  }
};
</script>

<style scoped>
.applicant-link {
  height: 100%;
}

.applicant-link .card {
  height: 100%;
  border: 2px solid #F6F6F6;
  border-radius: 10px;
}

.applicant-link .card .card-body {
  height: 100%;
  color: #64513D;
}

.applicant-link .card-top-row {
  display: grid;
  grid-auto-flow: column;
  position: absolute;
  top: -15px;
  left: 0;
  width: 100%;
}

.applicant-link .card-top-row .match_percentage,
.applicant-link .card-top-row .recent,
.applicant-link .card-top-row .declined {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 20px;
  font-weight: 400;
}

.applicant-link .card-top-row .match_percentage {
  height: 25px;
  width: 85px;
  background-color: #FFCD00;
}

.applicant-link .card-top-row .recent,
.applicant-link .card-top-row .declined {
  height: 25px;
  width: 115px;
  background-color: #F6F6F6;
}

.applicant-link .card-top-row .declined {
  width: 135px;
}

.applicant-link .applicant-card-image {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
}

.applicant-link .applicant-card-image .img-item {
  display: block;
  object-fit: cover;
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 100px;
  border: 2px solid #F6F6F6;
}

.applicant-link .applicant-card-image .img-item /deep/svg {
  width: 100%;
  height: 100%;
  padding: 2px;
}

.applicant-link .applicant-card-image .sd-title {
  margin-left: 10px;
}

.applicant-link .applicant-card-spec > div {
  display: flex;
}

.applicant-link .applicant-card-spec /deep/ svg {
  min-width: 15px;
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-top: 3px;
  color: #FFCD00;
}

.applicant-link .applicant-card-spec .achievements_container {
  margin-top: 15px;
}

.job-title {
  margin-bottom: 0;
}

.text.job {
  font-size: 11px;
  line-height: 150%;
}

.bg-cancelled {
  filter: grayscale(1);
  user-select: none;
}

</style>
